// Central registry for all legal/compliance pages.
// Used by routes, the marketing footer, and the legal page sidebar
// so links stay consistent across the entire site.

export const LEGAL_PAGES = [
  { slug: "privacy", path: "/privacy", title: "Privacy Policy", footerLabel: "Privacy Policy" },
  { slug: "terms", path: "/terms", title: "Terms of Service", footerLabel: "Terms of Service" },
  { slug: "disclaimer", path: "/disclaimer", title: "Risk Assessment Disclaimer", footerLabel: "Disclaimer" },
  { slug: "acceptable-use", path: "/acceptable-use", title: "Acceptable Use Policy", footerLabel: "Acceptable Use Policy" },
  { slug: "subscription-policy", path: "/subscription-policy", title: "Subscription & Billing Policy", footerLabel: "Subscription Policy" },
  { slug: "refund-policy", path: "/refund-policy", title: "Refund Policy", footerLabel: "Refund Policy" },
  { slug: "cookie-policy", path: "/cookie-policy", title: "Cookie Policy", footerLabel: "Cookie Policy" },
  { slug: "contact", path: "/contact", title: "Contact", footerLabel: "Contact" },
];

export const SUPPORT_EMAIL = "hostguardau@gmail.com";
export const PRIVACY_EMAIL = "hostguardau@gmail.com";
export const BILLING_EMAIL = "hostguardau@gmail.com";
